<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 md12 style="padding: 5px">
        <v-btn
          slot="activator"
          v-if="canSee('modifyForms')"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          to="/addForm"
        >
          <v-icon>add</v-icon>
        </v-btn>

        <div v-if="forms.length > 0">
          <v-data-iterator
            :items="forms"
            :items-per-page.sync="itemsPerPage"
            :search="search"
            row
            wrap
          >
            <template v-slot:header>
              <v-row>
                <v-col xs="12" sm="12" md="12" style="padding: 5px 20px;">
                  <v-text-field
                    v-model="search"
                    prepend-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item="props">
              <v-flex xs12 sm12 md12 style="padding: 10px 20px">
                <v-card style="border-radius: 2px; padding: 0px 10px">
                  <v-card-title>
                    <h4 style="font-size: 18px; font-weight: 500; letter-spacing: 0.5px">
                      {{ props.item.name }}
                    </h4>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="canSee('modifyForms')"
                      :to="{
                        name: 'Edit',
                        params: { updateFormId: props.item.id, formName: props.item.name }
                      }"
                      align="right"
                      fab
                      color="primary"
                      text
                      small
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn
                      v-if="$store.state.userDetails.role == 'SuperAdmin'"
                      align="right"
                      fab
                      color="error"
                      text
                      small
                    >
                      <v-icon @click="deleteForm(props.item)">delete</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-divider
                    style="margin: 0px 15px; background: #338AFF; border: 1px solid #338AFF"
                  ></v-divider>

                  <v-list dense style="padding: 15px">
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-icon class="grey lighten-1 white--text">assignment</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-sub-title
                          >Questions: {{ props.item.formStructures.length }}</v-list-item-sub-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-card-actions class="justify-center">
                    <v-btn
                      :to="{
                        name: 'Responses',
                        query: { formId: props.item.id, formName: props.item.name }
                      }"
                      class="primary"
                      text-color="white;"
                    >
                      Responses
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              class="white--text"
              icon="warning"
            >
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-iterator>
        </div>

        <div v-else align="center">
          <v-nodata
            :loading="loading.formOption"
            :networkError="networkError.formOption"
            @retryMethod="getForms"
            title=""
            msg-details="You haven’t added any forms yet"
            icon="clip-message-sent-1"
          >
          </v-nodata>
        </div>

        <!-- </v-list> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import canSee from "@/utilities/canSee";
import vueDropzone from "vue2-dropzone";
import VNodata from "@/components/Unavailable/nodata.vue";
import DisplayCard from "@/views/card.vue";

export default {
  components: { vueDropzone, VNodata, DisplayCard },
  data() {
    return {
      //rowsPerPageItems: [4, 8, 12],
      /* pagination: {
        rowsPerPage: 4
      },*/
      itemsPerPageArray: [4, 8, 12],
      itemsPerPage: 4,
      loading: {
        formOption: true
      },
      networkError: {
        formOption: false
      },
      dialog: false,
      addedQuestions: [],
      formsContents: [],
      required: false,
      forms: [],
      editedIndex: -1,
      setLoading: true,
      editedItem: {
        name: "",
        inputType: "text"
      },
      defaultItem: {
        name: "",
        inputType: "text"
      },
      formName: "",
      updateFormId: "",
      search: "",
      renderComponent: true
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Form" : "Edit Form";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.getForms();
  },
  methods: {
    canSee(what, role) {
      return canSee(this, what, role);
    },

    getForms() {
      this.loading.formOption = true;

      if (this.$store.state.userDetails.role == "User") {
        // include allowedForms
        const allowedForms = JSON.parse(JSON.stringify(this.$store.state.userDetails.allowedForms));
        // include ft allowedForms
        var fieldTrackingSettings = [];
        if (this.$store.getters.userDetails.fieldTrackingSettings.enabled) {
          fieldTrackingSettings = JSON.parse(
            JSON.stringify(this.$store.getters.userDetails.fieldTrackingSettings.formId)
          );
        }

        // const filter = { where: { id: { inq: fieldTrackingSettings } } };
        var filter = {
          where: {
            id: {
              inq: [...allowedForms, ...fieldTrackingSettings]
            }
          }
        };
        var url = `${this.$store.state.endpoint}forms?filter=${encodeURIComponent(
          JSON.stringify(filter)
        )}`;
      } else {
        var url = `${this.$store.state.endpoint}forms?filter[where][companyId]=${this.$store.state.userDetails.companyId}`;
      }

      // this.setLoading = true
      this.$http.get(url).then(
        response => {
          this.loading.formOption = false;

          this.forms = [];
          this.forms = response.body;

          var response = response.body;

          for (var f in response) {
            response[f].visible = true;
            // title
            response[f].title = response[f].name;
            // fields
            response[f].fields = {
              numberOfQuestions: "questions"
            };
            // permission type
            response[f].permissionType = "modifyForms";
            // contents
            var len = response[f].formStructures.length;
            response[f].contents = {
              len: len
            };

            this.formsContents.push(response[f]);
          }

          // this.setLoading = false
        },
        error => {
          // console.log(error);
          this.loading.formOption = false;
          this.networkError.formOption = true;
          // this.setLoading = false
          // error callback
        }
      );
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.formName = "";
        this.addedQuestions = [];
        this.updateFormId = "";
      }, 300);
    },
    deleteForm(item) {
      const itemObj = item.id;

      // write item delete code

      this.$swal({
        title: `Delete ${item.name}?`,
        text: "All form responses will be deleted. Please take a backup before deleting.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Proceed"
      }).then(result => {
        if (result.value) {
          this.$http.delete(`${this.$store.state.endpoint}forms/${itemObj}`).then(
            response => {
              this.getForms();
            },
            error => {
              console.log(error);
              // error callback
              this.$swal({
                type: "error",
                text: "Something went wrong. Try again later"
              });
            }
          );
        }
      });
    },

    editForm(item) {
      this.$router.push({
        name: "EditForm",
        params: { updateFormId: item.id, formName: item.name }
      });
    }
  }
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-list__tile__title,
.v-list__tile__sub-title {
  white-space: inherit !important;
  overflow: hidden;
  text-overflow: ellipsis;
  /* -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1); */
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}
</style>
